const requestColors = new Set(['Black','Columbia Blue','Cream','Navy','Red','Royal Blue','White','Black / Charcoal','Black / White','Charcoal / Black','Charcoal / Columbia Blue','Charcoal / Neon Blue','Charcoal / Neon Orange','Charcoal / Neon Pink','Charcoal / Red','Charcoal / Royal Blue','Columbia Blue / White','Heather Gray / White','Navy / Camel','Navy / Charcoal']);
const requestShapes = new Set(['Rectangle','Rounded Square','Circle','Oval','Hexagon','Custom Contour']);
const requestPurposes = new Set(['Artwork review before ordering','Custom hats','Engraved keepsake','Business or bulk order','Other custom idea']);
const requestBindings = new WeakMap();
function bindRequestContext() {
  document.querySelectorAll('[data-request-context]').forEach((context) => {
    const form = context.closest('form');
    if (!form) return;
    requestBindings.get(form)?.abort();
    const controller = new AbortController();
    requestBindings.set(form, controller);
    const fields = Object.fromEntries(['purpose','product','color','shape'].map(key => [key, context.querySelector(`[data-request-${key}]`)]));
    if (Object.values(fields).some(field => !field)) return;
    const project = context.querySelector('[data-request-project]');
    const details = context.querySelector('[data-request-details]');
    const storageKey = `evermarkd:request-context:${location.pathname}:${form.id}`;
    const result = form.querySelector('[data-contact-result]')?.dataset.contactResult || 'initial';
    const valid = (key, value) => typeof value === 'string' && value.length <= 80 && (value === '' || (key === 'purpose' ? requestPurposes.has(value) : key === 'product' ? Array.from(fields.product.options).some(option => option.value === value) : key === 'color' ? requestColors.has(value) : requestShapes.has(value)));
    const fillBlank = (key, value) => { if (!fields[key].value && valid(key, value)) fields[key].value = value; };
    try {
      if (result === 'success') sessionStorage.removeItem(storageKey);
      else if (result !== 'error') {
        const saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
        if (saved && Number.isFinite(saved.savedAt) && Date.now() - saved.savedAt >= 0 && Date.now() - saved.savedAt < 86400000) Object.keys(fields).forEach(key => fillBlank(key, saved.values?.[key]));
      }
    } catch {}
    if (result !== 'error' && result !== 'success') {
      const params = new URLSearchParams(location.search);
      const product = params.get('product') || '';
      if (params.get('intent') === 'business') {
        fillBlank('purpose', 'Business or bulk order');
        if (valid('product', product)) fillBlank('product', product);
      }
      if (params.get('intent') === 'artwork-review' && product && valid('product', product)) {
        fillBlank('purpose', 'Artwork review before ordering');
        fillBlank('product', product);
        if (product === 'personalized-custom-leatherette-patch-hat' && fields.product.value === product) {
          fillBlank('color', params.get('color') || '');
          fillBlank('shape', params.get('shape') || '');
        }
        const note = context.querySelector('[data-request-context-note]');
        if (note) note.hidden = false;
      }
      if (!fields.purpose.value && requestPurposes.has(project?.value)) fields.purpose.value = project.value;
    }
    const update = (openDetails = false) => {
      const review = fields.purpose.value === 'Artwork review before ordering';
      const note = context.querySelector('[data-request-review-note]');
      if (note) note.hidden = !review;
      const isHat = fields.product.value ? fields.product.value === 'personalized-custom-leatherette-patch-hat' : fields.purpose.value === 'Custom hats';
      const hatFields = context.querySelector('[data-request-hat-fields]');
      if (hatFields) hatFields.hidden = !isHat;
      fields.color.disabled = fields.shape.disabled = !isHat;
      if (project) project.value = fields.purpose.value || 'General question';
      if (details && openDetails && (fields.purpose.value || fields.product.value)) details.open = true;
    };
    const save = event => {
      update(event?.target === fields.purpose || event?.target === fields.product);
      try { sessionStorage.setItem(storageKey, JSON.stringify({savedAt: Date.now(), values: Object.fromEntries(Object.entries(fields).map(([key, field]) => [key, field.value.slice(0,80)]))})); } catch {}
    };
    for (const event of ['input','change','submit']) form.addEventListener(event, save, {signal: controller.signal});
    update(true);
  });
}
customElements.whenDefined('evermarkd-contact-draft').then(() => {
  requestAnimationFrame(bindRequestContext);
  document.addEventListener('shopify:section:load', bindRequestContext);
  document.addEventListener('evermarkd:contact-restored', bindRequestContext);
});
